import React, { Component } from "react";
import { Card, CardTitle, FlatButton, Divider } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import formatDate from "../../../utils/formatDate";
import FilterIndex from "../FilterIndex";

export default class UploadIndex extends Component {
  constructor(props) {
    super(props);

    this.downloadButton = this.downloadButton.bind(this);
    this.openDocInWindow = this.openDocInWindow.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  downloadButton(cell, row) {
    return (
      <FlatButton
        label="Download"
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        onClick={this.openDocInWindow.bind(this, row._id)}
      />
    );
  }

  openDocInWindow(docId) {
    window.open(`/api/unAuth/getDocById?id=${docId}`);
  }

  renderTable() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      return (
        <div>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="clientId"
              filter={filter}
              dataSort
              isKey
              width="55"
            >
              Client ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              width="200"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="year"
              dataSort
              filter={filter}
              width="50"
            >
              Year
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="type"
              dataSort
              filter={filter}
              width="200"
            >
              Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="pages"
              dataSort
              filter={filter}
              width="50"
            >
              Pages
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              width="100"
              dataFormat={this.downloadButton}
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  render() {
    return (
      <Card
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", padding: "2em 7em 0em 7em" }}
      >
        <CardTitle title="Documents" />
        <Divider style={{ margin: "1em 1em" }} />
        <FilterIndex
          url="documentUpload/docRecords"
          filterKey="type"
          {...this.props}
        />
        <br />
        {this.renderTable()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documents/UploadIndex.js